export function getAllLegalItems(axiosPrivate) {
  return axiosPrivate.get('/legal-tina')
}

export function deleteLegalItem(axiosPrivate, id) {
  return axiosPrivate.delete(`/legal-tina/${id}`)
}
